import { Constants } from "../../components/Constants";
import EzUtils from "../../utils/EzUtils";
import StorageUtil from "../../utils/StorageUtil";

const CO_BRANDING_DATA = "coBrandingData";

export default {

  clearCoBrandingData() {
    StorageUtil.removeItem(CO_BRANDING_DATA);
  },

  setCoBrandingData(coBrandingData) {
    if(coBrandingData){
      StorageUtil.setItem(CO_BRANDING_DATA, JSON.stringify(coBrandingData));
    } else{
      this.clearCoBrandingData();
    }
  },

  getCoBrandingData() {
    const coBrandingData = EzUtils.convertToJSONObjectIfString(
      StorageUtil.getItem(CO_BRANDING_DATA)
    );
    return coBrandingData ? coBrandingData : {};
  },

  getCoBrandingLogoText(){
    const coBrandingData = EzUtils.convertToJSONObjectIfString(
      StorageUtil.getItem(CO_BRANDING_DATA)
    );
    return coBrandingData ? coBrandingData.coBrandingLogoText : "";
  },

  getCoBrandingLogoUrl(){
    const coBrandingData = EzUtils.convertToJSONObjectIfString(
      StorageUtil.getItem(CO_BRANDING_DATA)
    );
    return coBrandingData ? coBrandingData.coBrandingLogoUrl : "";
  },
  
  getRetailerBenefitTitle(){
    const coBrandingData = EzUtils.convertToJSONObjectIfString(
      StorageUtil.getItem(CO_BRANDING_DATA)
    );
    return coBrandingData ? coBrandingData.retailerBenefitTitle : "";
  },

  getRetailerHeadingTitle(){
    const coBrandingData = EzUtils.convertToJSONObjectIfString(
      StorageUtil.getItem(CO_BRANDING_DATA)
    );
    return coBrandingData ? coBrandingData.retailerHeadingTitle : "";
  },

  getRetailerHeadingDescription(){
    const coBrandingData = EzUtils.convertToJSONObjectIfString(
      StorageUtil.getItem(CO_BRANDING_DATA)
    );
    return coBrandingData ? coBrandingData.retailerHeadingDescription : "";
  },

  getRetailerNoneDefaultProcessSteps(){
    const coBrandingData = EzUtils.convertToJSONObjectIfString(
      StorageUtil.getItem(CO_BRANDING_DATA)
    );
    return coBrandingData ? coBrandingData.retailerNoneDefaultProcessSteps : [];
  },

  getRetailerProcessConfig(){
    const coBrandingData = EzUtils.convertToJSONObjectIfString(
      StorageUtil.getItem(CO_BRANDING_DATA)
    );
    return coBrandingData ? coBrandingData.retailerProcessConfig : {};
  },

  showRetailerLandingPage(){
    const coBrandingData = EzUtils.convertToJSONObjectIfString(
      StorageUtil.getItem(CO_BRANDING_DATA)
    );
    return coBrandingData ? coBrandingData.showRetailerLandingPage : true;
  },

  showRetailerOnBoardingExtraDetails(){
    const coBrandingData = EzUtils.convertToJSONObjectIfString(
      StorageUtil.getItem(CO_BRANDING_DATA)
    );
    return coBrandingData ? coBrandingData.showRetailerOnBoardingExtraDetails : false;
  },

  getEzCredJourneyType(){
    const coBrandingData = EzUtils.convertToJSONObjectIfString(
      StorageUtil.getItem(CO_BRANDING_DATA)
    );
    return coBrandingData && coBrandingData.ezCredJourneyType 
      ? coBrandingData.ezCredJourneyType : Constants.EZCRED_JOURNEY_TYPE_SELF;
  },

  clearEzCredJourneyType(){
    let coBrandingData = EzUtils.convertToJSONObjectIfString(
      StorageUtil.getItem(CO_BRANDING_DATA)
    );
    if(coBrandingData){
      delete coBrandingData.ezCredJourneyType;
      this.setCoBrandingData(coBrandingData);
    }
  },

  isURLValid(){
    // const coBrandingData = EzUtils.convertToJSONObjectIfString(
    //   StorageUtil.getItem(CO_BRANDING_DATA)
    // );
    // return coBrandingData && coBrandingData.validUrl 
    //   ? coBrandingData.validUrl : false;
    return true;
  },

};

